/* A product's pictures and buying form — on the product page, and in the
 * collection's quick view, which calls window.jwProduct(root) on the markup
 * it has just put in. Everything is looked up inside `root`.
 */
(function () {
  /* The picture full screen (snippets/zoom, Max, 2026-09-28), on every
     width since 2026-10-25: on a phone pinching the page fought the row's
     swipe, so a tap opens this too.
     It shows the row's current picture at once and swaps in the 2400px file
     when that has loaded. Closing hands the index back, so the row stays on
     the last picture seen.
     The picture is at its own size, as large as the 2400px file, and the
     dialog scrolls round it: dragged with a mouse, a trackpad or a finger
     as usual (Max, 2026-10-17; it was fitted to the screen). It opens on
     the spot clicked; a step opens the next one at its middle. A click
     that was not a drag closes it, as before. On a phone (under 721px) the
     picture is 2.5 screens wide rather than its own size, which would be
     six, and a finger moves round it by scrolling the dialog. */
  var desk = window.matchMedia('(min-width: 721px)');
  var zoom = (function () {
    var dlg = document.getElementById('jw-zoom');
    if (!dlg || !dlg.showModal) return null;
    var pic = dlg.querySelector('[data-zoom-img]');
    var now = dlg.querySelector('[data-zoom-now]');
    var list = [], i = 0, done = null, dragged = false;
    function paint(fx, fy) {
      var img = list[i];
      var w = +img.getAttribute('width') || 2400, h = +img.getAttribute('height') || 2400;
      var big = Math.min(w, 2400);   // image_url never makes a picture larger than it is
      if (!desk.matches) big = Math.min(big, Math.round(dlg.clientWidth * 2.5));
      pic.style.width = big + 'px';
      pic.style.height = Math.round(h * big / w) + 'px';
      pic.src = img.currentSrc || img.src;
      pic.alt = img.alt;
      now.textContent = i + 1;
      // The margins centre a picture smaller than the screen, so measure where it lands.
      var x = pic.offsetLeft + pic.offsetWidth * (fx == null ? .5 : fx);
      var y = pic.offsetTop + pic.offsetHeight * (fy == null ? .5 : fy);
      dlg.scrollTo(x - dlg.clientWidth / 2, y - dlg.clientHeight / 2);
      var big = new Image();
      big.src = img.dataset.zoom;
      big.decode().then(function () { if (list[i] === img) pic.src = big.src; }).catch(function () {});
    }
    function step(d) { i = (i + d + list.length) % list.length; paint(); }
    dlg.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button')) return;
      e.preventDefault();   // no picture ghost, no text selection
      var x = e.clientX, y = e.clientY;
      dragged = false;
      dlg.classList.add('jw-zoom--drag');
      function move(m) {
        if (Math.abs(m.clientX - x) + Math.abs(m.clientY - y) > 3) dragged = true;
        dlg.scrollBy(x - m.clientX, y - m.clientY);
        x = m.clientX; y = m.clientY;
      }
      function up() {
        dlg.classList.remove('jw-zoom--drag');
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
      }
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zoom-step]');
      if (b) step(+b.dataset.zoomStep); else if (!dragged) dlg.close();
      dragged = false;
    });
    dlg.addEventListener('keydown', function (e) {
      if (list.length < 2) return;
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
    dlg.addEventListener('close', function () { if (done) done(i, true); });
    return function (imgs, start, onClose, fx, fy) {
      list = imgs; i = start; done = onClose;
      dlg.querySelector('[data-zoom-total]').textContent = imgs.length;
      dlg.classList.toggle('jw-zoom--one', imgs.length < 2);
      dlg.showModal();   // first, so the dialog has a size to scroll in
      paint(fx, fy);
    };
  })();

  function init(root) {
    // The picture row. A thumb moves it to its picture, and the row's position
    // decides which thumb wears the ring — so a swipe, a trackpad and a thumb
    // all agree. On a phone the row loops as the arrows do: a swipe on past
    // the last picture goes to the first, and back past the first goes to the
    // last. The browser stops a scroll at either end, so this watches the
    // finger there instead (40px or more beyond the end).
    var gallery = (function () {
      var row = root.querySelector('[data-gallery]');
      if (!row) return null;
      var thumbs = root.querySelectorAll('[data-thumb]');
      var count = root.querySelector('[data-gallery-now]');
      /* The ring and "1/7" go straight to the picture asked for, and the row's
         scroll stops moving them until it gets there: a click on the tenth
         thumb rings the tenth, not each one the row passes (Max, 2026-10-17).
         A finger or a wheel on the row takes over from the click. */
      var target = null, shown = 0;
      function mark(now) {
        if (count) count.textContent = now + 1;
        thumbs.forEach(function (t) {
          if (+t.dataset.thumb !== now) { t.removeAttribute('aria-current'); return; }
          t.setAttribute('aria-current', 'true');
          // The column scrolls when the thumbs outgrow the picture: this one to its middle, as near as the ends allow.
          var col = t.parentNode;
          col.scrollTo({ top: t.offsetTop + t.offsetHeight / 2 - col.clientHeight / 2, behavior: 'smooth' });
        });
      }
      function show(i, instant) {
        target = shown = i;
        mark(i);
        row.scrollTo({ left: i * row.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.thumb); }); });
      /* The arrows, over the picture and under it, step one picture, round
       from either end. */
      root.querySelectorAll('[data-gallery-step]').forEach(function (a) {
        a.addEventListener('click', function () {
          var n = row.children.length, now = target !== null ? target : Math.round(row.scrollLeft / row.clientWidth);
          show((now + +a.dataset.galleryStep + n) % n);
        });
      });
      ['pointerdown', 'wheel'].forEach(function (type) {
        row.addEventListener(type, function () { target = null; }, { passive: true });
      });
      var queued = false;
      row.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          var now = Math.round(row.scrollLeft / row.clientWidth);
          if (target !== null) {
            if (now !== target) return;
            target = null;
          }
          if (now !== shown) { shown = now; mark(now); }
        });
      }, { passive: true });
      row.addEventListener('click', function (e) {
        var img = e.target.closest('img');
        if (!img || !zoom) return;
        var imgs = Array.prototype.slice.call(row.querySelectorAll('img'));
        // The spot clicked, as a share of the picture: object-fit: contain may leave bands round it.
        var r = img.getBoundingClientRect(), k = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
        var dw = img.naturalWidth * k, dh = img.naturalHeight * k;
        var fx = (e.clientX - r.left - (r.width - dw) / 2) / dw, fy = (e.clientY - r.top - (r.height - dh) / 2) / dh;
        zoom(imgs, imgs.indexOf(img), show, Math.min(Math.max(fx, 0), 1), Math.min(Math.max(fy, 0), 1));
      });
      var startX = null, atStart = false, atEnd = false;
      row.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        var more = row.scrollWidth > row.clientWidth;
        atStart = more && row.scrollLeft <= 2;
        atEnd = more && row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      }, { passive: true });
      row.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var moved = startX - e.changedTouches[0].clientX;   /* > 0: the finger went left */
        if (atEnd && moved >= 40) show(0);
        else if (atStart && moved <= -40) show(row.children.length - 1);
        startX = null;
      }, { passive: true });
      return { show: show };
    })();

    // A chosen card sets the name after the legend, the price, the button and
    // ?variant= in the address, and moves the row to the variant's picture when
    // it has one. The form itself needs none of this: the radio IS the id.
    // The history state is kept: the quick view's entry is marked by it.
    var form = root.querySelector('.jw-buy');
    if (!form) return;
    // The quantity's - and +: one step, never below 1. The grey lets go
    // once the step is taken (jw.css, .jw-buy__stepper--rest).
    form.querySelectorAll('[data-qty-step]').forEach(function (b) {
      var pill = b.parentNode;
      b.addEventListener('click', function () {
        var field = pill.querySelector('input');
        field.value = Math.max(1, (parseInt(field.value, 10) || 1) + +b.dataset.qtyStep);
        pill.classList.add('jw-buy__stepper--rest');
      });
      b.addEventListener('pointerdown', function () { pill.classList.remove('jw-buy__stepper--rest'); });
      b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') pill.classList.remove('jw-buy__stepper--rest'); });
    });
    var price = root.querySelector('[data-buy-price]');
    var button = form.querySelector('[data-buy-button]');
    var chosen = form.querySelector('[data-buy-chosen]');
    // A line per option (snippets/product-buy), one option or several. A
    // choice finds the variant the lines add up to, puts it on the hidden
    // id and sends that a change, so what follows (and the quick view's
    // foot) treats it as one card chosen. Each value is struck through when
    // it is sold out, or does not exist, with the other lines as they stand.
    var id = form.querySelector('[data-buy-id]');
    var variants = id ? JSON.parse(form.querySelector('[data-buy-variants]').textContent) : [];
    var lines = id ? form.querySelectorAll('[data-buy-option]') : [];
    function picks() {
      return Array.prototype.map.call(lines, function (f) { var r = f.querySelector('input:checked'); return r ? r.value : null; });
    }
    function find(want) {
      return variants.filter(function (v) { return want.every(function (o, i) { return v.options[i] === o; }); })[0];
    }
    function strike() {
      var now = picks();
      lines.forEach(function (f, i) {
        f.querySelectorAll('input').forEach(function (r) {
          var want = now.slice(); want[i] = r.value;
          var v = find(want);
          r.parentNode.classList.toggle('jw-option--out', !v || !v.available);
        });
      });
    }
    if (id) strike();
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (id && r.name.indexOf('jw-option-') === 0) {
        var chosenHere = r.closest('[data-buy-option]').querySelector('[data-buy-option-chosen]');
        if (chosenHere) chosenHere.textContent = r.value;
        var v = find(picks());
        if (v) {
          id.value = v.id;
          id.dataset.title = v.title; id.dataset.price = v.price; id.dataset.compare = v.compare;
          if (v.picture === null) delete id.dataset.picture; else id.dataset.picture = v.picture;
        }
        id.toggleAttribute('data-sold-out', !v || !v.available);
        id.toggleAttribute('data-missing', !v);
        strike();
        id.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      if (r.name !== 'id') return;
      var out = r.disabled || r.hasAttribute('data-sold-out');
      if (chosen) chosen.textContent = r.dataset.title;
      price.innerHTML = r.dataset.price + (r.dataset.compare ? ' <s>' + r.dataset.compare + '</s>' : '');
      if (gallery && r.dataset.picture) gallery.show(+r.dataset.picture);
      if (button) {   /* the quick view's is in the drawer's foot */
        button.disabled = out;
        button.textContent = r.hasAttribute('data-missing') ? 'Unavailable' : out ? 'Sold out' : 'Add to bag';
      }
      if (!r.hasAttribute('data-missing')) history.replaceState(history.state, '', '?variant=' + r.value);
    });
    /* Opened from a ?variant= link to a variant with its own picture: start
       on it. A plain product link opens on the product's first picture. */
    var start = form.querySelector('input[name="id"]:checked') || id;
    if (gallery && /[?&]variant=/.test(location.search) && start && start.dataset.picture) gallery.show(+start.dataset.picture, true);
  }

  /* You may also like, under the product page (Max, 2026-09-29): the bag's
     recommendations section asked for this product — Shopify's picks, then
     the rest of the store in a random order — four cards, not this one. */
  var also = document.querySelector('[data-alsolike]');
  if (also) {
    fetch('/recommendations/products?section_id=cart-recommendations&limit=10&product_id=' + also.dataset.alsolike, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var picked = [], pool = [], seen = {};
        seen[also.dataset.alsolike] = true;
        tmp.querySelectorAll('[data-id]').forEach(function (el) { (el.hasAttribute('data-rec') ? picked : pool).push(el); });
        for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = pool[i]; pool[i] = pool[j]; pool[j] = t; }
        var cards = [];
        picked.concat(pool).forEach(function (el) {
          if (cards.length < 4 && !seen[el.dataset.id]) { seen[el.dataset.id] = true; cards.push(el.firstElementChild); }
        });
        if (!cards.length) return;
        var list = also.querySelector('[data-alsolike-list]');
        list.replaceChildren.apply(list, cards);
        also.hidden = false;
      })
      .catch(function () {});
  }

  window.jwProduct = init;
  document.querySelectorAll('[data-product]').forEach(init);
})();
